import SectionCard from "./SectionCard";

export default function EducationTab({ candidate }) {
  const items = candidate.education || [];

  return (
    <>
      <SectionCard title="Education">
        {!items.length ? (
          <div style={{ textAlign: "center", padding: "24px 0" }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: "var(--fc-border-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
              <i className="fa-solid fa-graduation-cap" style={{ fontSize: 18, color: "var(--fc-text-hint)" }} />
            </div>
            <p style={{ color: "var(--fc-text-subtle)", fontSize: 13, margin: 0 }}>No education details added yet.</p>
          </div>
        ) : (
          items.map((edu, i) => (
            <div key={i} style={{
              display: "flex", gap: 14,
              paddingBottom: i < items.length - 1 ? 20 : 0,
              marginBottom:  i < items.length - 1 ? 20 : 0,
              borderBottom:  i < items.length - 1 ? "1px solid var(--fc-border-light)" : "none",
            }}>
              {/* Icon */}
              <div style={{ flexShrink: 0 }}>
                <div style={{ width: 42, height: 42, borderRadius: 11, background: "var(--fc-primary-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="fa-solid fa-graduation-cap" style={{ color: "#2563EB", fontSize: 16 }} />
                </div>
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: "var(--fc-text-primary)", lineHeight: 1.3 }}>
                  {edu.degree}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "var(--fc-blue)", marginTop: 2 }}>
                  {edu.school}
                </div>
                {edu.period && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                    <i className="fa-regular fa-calendar" style={{ fontSize: 10, color: "var(--fc-text-subtle)" }} />
                    <span style={{ fontSize: 12, color: "var(--fc-text-subtle)", fontWeight: 500 }}>{edu.period}</span>
                  </div>
                )}
                {edu.grade && (
                  <span style={{ display: "inline-block", marginTop: 6, fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 99, background: "var(--fc-green-light)", color: "var(--fc-green-text)" }}>
                    {edu.grade}
                  </span>
                )}
                {edu.desc && (
                  <p style={{ fontSize: 13, color: "var(--fc-text-muted)", lineHeight: 1.65, margin: "6px 0 0" }}>{edu.desc}</p>
                )}
              </div>
            </div>
          ))
        )}
      </SectionCard>

    </>
  );
}
